import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import {
  DOCUMENTS__DOCUMENT_BLOCK_FAILURE,
  DOCUMENTS__DOCUMENT_BLOCK_REQUEST,
  DOCUMENTS__DOCUMENT_BLOCK_SUCCESS,
  DOCUMENTS__DOCUMENT_PROGRESS_REJECT_FAILURE,
  DOCUMENTS__DOCUMENT_PROGRESS_REJECT_REQUEST,
  DOCUMENTS__DOCUMENT_PROGRESS_REJECT_SUCCESS,
  DOCUMENTS__DOCUMENT_REUSE_FAILURE,
  DOCUMENTS__DOCUMENT_REUSE_REQUEST,
  DOCUMENTS__DOCUMENT_REUSE_SUCCESS,
  DOCUMENTS__DOCUMENT_UNBLOCK_FAILURE,
  DOCUMENTS__DOCUMENT_UNBLOCK_REQUEST,
  DOCUMENTS__DOCUMENT_UNBLOCK_SUCCESS,
  DOCUMENTS__SIGNING_CANCEL_FAILURE,
  DOCUMENTS__SIGNING_CANCEL_REQUEST,
  DOCUMENTS__SIGNING_CANCEL_SUCCESS,
  DOCUMENTS__UNARCHIVE_FAILURE,
  DOCUMENTS__UNARCHIVE_SUCCESS,
} from '@app/store/actionTypes';

/**
 * 문서를 차단한다.
 */
export function blockDocument(payload: { documentId: string; invalidate?: () => void }) {
  return {
    type: DOCUMENTS__DOCUMENT_BLOCK_REQUEST,
    payload,
  };
}
export function blockDocumentSuccess() {
  return {
    type: DOCUMENTS__DOCUMENT_BLOCK_SUCCESS,
  };
}
export function blockDocumentFailure(error: AxiosError) {
  return {
    type: DOCUMENTS__DOCUMENT_BLOCK_FAILURE,
    payload: error,
    error: true,
  };
}

/**
 * 이미 서명 완료한 계약에 대해 자신의 서명을 취소한다.
 */
export function cancelSigning({
  documentId,
  participantId,
  message,
  isDocumentBlock,
}: {
  documentId: string;
  participantId: string;
  message: string;
  isDocumentBlock: boolean;
}) {
  return {
    type: DOCUMENTS__SIGNING_CANCEL_REQUEST,
    payload: {
      documentId,
      participantId,
      message,
      isDocumentBlock,
    },
  };
}
export const cancelSigningSuccess = createAction(DOCUMENTS__SIGNING_CANCEL_SUCCESS);

export function cancelSigningFailure(error: AxiosError) {
  return {
    type: DOCUMENTS__SIGNING_CANCEL_FAILURE,
    payload: error,
    error: true,
  };
}

/**
 * 문서 진행을 거절한다.
 */
export function rejectDocument({
  documentId,
  participantId,
  message,
  isDocumentBlock,
}: {
  documentId: string;
  participantId: string;
  message: string;
  isDocumentBlock: boolean;
}) {
  return {
    type: DOCUMENTS__DOCUMENT_PROGRESS_REJECT_REQUEST,
    payload: {
      documentId,
      participantId,
      message,
      isDocumentBlock,
    },
  };
}
export const rejectDocumentSuccess = createAction(DOCUMENTS__DOCUMENT_PROGRESS_REJECT_SUCCESS);

export function rejectDocumentFailure(error: AxiosError) {
  return {
    type: DOCUMENTS__DOCUMENT_PROGRESS_REJECT_FAILURE,
    payload: error,
    error: true,
  };
}

export function reuseDocument(payload: { documentId: string; documentName: string }) {
  return {
    type: DOCUMENTS__DOCUMENT_REUSE_REQUEST,
    payload,
  };
}

export const reuseDocumentSuccess = createAction(DOCUMENTS__DOCUMENT_REUSE_SUCCESS);

export function reuseDocumentFailure(error: AxiosError) {
  return {
    type: DOCUMENTS__DOCUMENT_REUSE_FAILURE,
    payload: error,
    error: true,
  };
}

/**
 * 문서 차단을 해제한다.
 */
export function unBlockDocument(payload: { documentId: string; invalidate?: () => void }) {
  return {
    type: DOCUMENTS__DOCUMENT_UNBLOCK_REQUEST,
    payload,
  };
}
export function unBlockDocumentSuccess() {
  return {
    type: DOCUMENTS__DOCUMENT_UNBLOCK_SUCCESS,
  };
}
export function unBlockDocumentFailure(error: AxiosError) {
  return {
    type: DOCUMENTS__DOCUMENT_UNBLOCK_FAILURE,
    payload: error,
    error: true,
  };
}

export function unarchiveDocumentsSuccess({ documentIds }: { documentIds: string[] }) {
  return {
    type: DOCUMENTS__UNARCHIVE_SUCCESS,
    payload: { documentIds },
  };
}
export function unarchiveDocumentsFailure(error: Error) {
  return {
    type: DOCUMENTS__UNARCHIVE_FAILURE,
    payload: error,
    error: true,
  };
}

export type DocumentsAction =
  | ReturnType<typeof blockDocument>
  | ReturnType<typeof blockDocumentSuccess>
  | ReturnType<typeof blockDocumentFailure>
  | ReturnType<typeof cancelSigning>
  | ReturnType<typeof cancelSigningSuccess>
  | ReturnType<typeof cancelSigningFailure>
  | ReturnType<typeof rejectDocument>
  | ReturnType<typeof rejectDocumentSuccess>
  | ReturnType<typeof rejectDocumentFailure>
  | ReturnType<typeof reuseDocument>
  | ReturnType<typeof reuseDocumentSuccess>
  | ReturnType<typeof reuseDocumentFailure>
  | ReturnType<typeof unBlockDocument>
  | ReturnType<typeof unBlockDocumentSuccess>
  | ReturnType<typeof unBlockDocumentFailure>
  | ReturnType<typeof unarchiveDocumentsSuccess>
  | ReturnType<typeof unarchiveDocumentsFailure>;
